import { IInputModel, IOptions } from "app/interfaces/input/input.interface";

const statusList: IOptions[] = [
	{
		value: 'Active',
		label: 'Active',
	},
	{
		value: 'Funded',
		label: 'Funded',
	},
	{
		value: 'Late',
		label: 'Late',
	},
];

const PortofolioFilterForm: IInputModel[] = [
	{
		id: 'name',
		formType: '',
		placeholder: 'Nama',
		name: 'name',
		apiErrorMessage: '',
		options: [],
		value: '',
	},
	{
		id: 'loanNumber',
		formType: '',
		placeholder: 'Loan Number',
		name: 'loanNumber',
		apiErrorMessage: '',
		options: [],
		value: '',
	},
	{
		id: 'status',
		formType: 'select',
		placeholder: 'Pilih status',
		name: 'loanStatus',
		apiErrorMessage: '',
		options: statusList,
		value: '',
	},
];

export default PortofolioFilterForm;
